<script setup lang="ts">
import { useTranslation } from '@/plugins/i18n/useTranslation';
import BaseIcon from './BaseIcon.vue';

export type ButtonProps = {
  color?: string;
  variant?: 'flat' | 'outlined' | 'tonal' | 'plain' | 'text';
  prependIcon?: string;
  appendIcon?: string;
  loading?: boolean;
  type?: 'button' | 'submit';
  disabled?: boolean;
  dataCy?: string;
  text?: string;
  icon?: string;
  iconSize?: number;
  iconClass?: string;
};

const { t } = useTranslation();

const props = defineProps<ButtonProps>();
</script>

<template>
  <v-btn
    class="px-3"
    :append-icon="props.appendIcon"
    :prepend-icon="props.prependIcon"
    :icon="props.icon"
    :variant="props.variant || 'flat'"
    :color="props.color || 'neutral'"
    :loading="props.loading || false"
    :type="props.type || 'button'"
    :disabled="props.disabled"
    :data-cy="props.dataCy"
  >
    <slot>
      <span
        v-if="props.icon"
        class="icon-container d-flex justify-center align-center"
      >
        <BaseIcon
          :icon="props.icon"
          :size="props.iconSize || 18"
        />
      </span>
    </slot>
    <slot
      v-if="props.text"
      name="append"
    >
      {{ t(props.text || '') }}
    </slot>
  </v-btn>
</template>
<style scoped lang="scss">
.v-btn {
  &.v-btn--disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }

  &:not(.v-btn--disabled) {
  &.bg-success:hover {
    background-color: #218838 !important;
  }

  &.bg-neutral:hover {
    background-color: #5a6268 !important;
  }

  &.bg-primary:hover {
    background-color: rgb(var(--v-theme-primary-500)) !important;
  }

  &.bg-red-600:hover {
    background-color: #bd2130 !important;
  }
  &.bg-error:hover {
    background-color: rgb(var(--v-theme-error-600)) !important;
  }
}
}
:deep(.v-btn__content) {
  text-transform: none;

  .icon-container {
    margin-top: 2px;
  }
}
</style>
